import React from 'react';
import Box from 'core/ui/Box';
import { secondaryLight } from 'core/ui/Colors';
import { Droppable } from 'react-beautiful-dnd';
import uuid from 'react-uuid';
import ItemTeam from './ItemTeam';

const ListCompTeams = ({ leaderboard, compUsers, workout }) => {
  const styleBox = {
    border: `0.5px solid ${secondaryLight}`,
  };
  const totalLen = leaderboard && leaderboard.length;
  return (
    <Box style={styleBox}>
      <Droppable droppableId="TEAMS-ALL">
        {(provided) => (
          <Box ref={provided.innerRef}>
            {compUsers &&
              compUsers.map((item, index) => {
                const board = leaderboard.find((x) => x.user.id === item.user.id);
                return (
                  <ItemTeam
                    item={item}
                    workout={workout}
                    totalLen={totalLen}
                    index={index}
                    leaderboard={board || {}}
                    key={uuid()}
                    dropable
                  />
                );
              })}

            {provided.placeholder}
          </Box>
        )}
      </Droppable>
    </Box>
  );
};

export default ListCompTeams;
